import axios from 'axios';
import Config from '@/Config';

const hostReservas = Config.host + "Reservations/"
const hostMesas = Config.host + "CompanyTables/"

/**
 * El backend manda sus mensajes en data.message (gracias a
 * server.error.include-message=always). Algunos controladores viejos responden
 * con el texto plano en el body, por eso se contemplan los dos casos.
 */
function mensajeDeError(error, porDefecto) {
  const data = error.response ? error.response.data : null

  if (data && data.message) {
    return data.message
  }
  if (typeof data === 'string' && data.trim() !== '') {
    return data
  }
  return porDefecto
}

function lanzarError(error, porDefecto) {
  throw new Error(mensajeDeError(error, porDefecto))
}

/* ---------------------------------- Reservas --------------------------------- */

/**
 * @param {number} idEmpresa
 * @param {string} fecha  'YYYY-MM-DD'. Si va null trae todas las fechas.
 * @param {string} estado pendiente | confirmada | cumplida | cancelada, o null para todas
 * @param {number} pagina base 0, como la espera el backend
 */
function listarReservas(idEmpresa, fecha = null, estado = null, pagina = 0) {
  const params = { page: pagina }

  if (fecha) {
    params.date = fecha
  }
  if (estado) {
    params.state = estado
  }

  return axios.get(`${hostReservas}company/${idEmpresa}`, { params })
    .then(respuesta => respuesta.data)
    .catch(error => lanzarError(error, "No se pudieron cargar las reservas"))
}

function resumenReservas(idEmpresa, fecha = null) {
  const params = {}

  if (fecha) {
    params.date = fecha
  }

  return axios.get(`${hostReservas}company/${idEmpresa}/summary`, { params })
    .then(respuesta => respuesta.data)
    .catch(error => lanzarError(error, "No se pudo cargar el resumen del dia"))
}

function guardarReserva(reserva) {
  return axios.post(`${hostReservas}save`, reserva)
    .then(respuesta => respuesta.data)
    .catch(error => lanzarError(error, "No se pudo guardar la reserva"))
}

function cambiarEstadoReserva(idReserva, estado) {
  // PUT y no PATCH: la configuracion de CORS del backend no permite PATCH
  return axios.put(`${hostReservas}${idReserva}/state`, { state: estado })
    .then(respuesta => respuesta.data)
    .catch(error => lanzarError(error, "No se pudo cambiar el estado de la reserva"))
}

function eliminarReserva(idReserva) {
  return axios.delete(`${hostReservas}delete/${idReserva}`)
    .then(respuesta => respuesta.data)
    .catch(error => lanzarError(error, "No se pudo eliminar la reserva"))
}

/* ----------------------------------- Mesas ----------------------------------- */

function listarMesas(idEmpresa, soloActivas = false) {
  return axios.get(`${hostMesas}company/${idEmpresa}`, {
    params: { onlyActive: soloActivas }
  })
    .then(respuesta => respuesta.data)
    .catch(error => lanzarError(error, "No se pudieron cargar las mesas"))
}

function guardarMesa(mesa) {
  return axios.post(`${hostMesas}save`, mesa)
    .then(respuesta => respuesta.data)
    .catch(error => lanzarError(error, "No se pudo guardar la mesa"))
}

function eliminarMesa(idMesa) {
  return axios.delete(`${hostMesas}delete/${idMesa}`)
    .then(respuesta => respuesta.data)
    .catch(error => lanzarError(error, "No se pudo eliminar la mesa"))
}

export default {
  listarReservas,
  resumenReservas,
  guardarReserva,
  cambiarEstadoReserva,
  eliminarReserva,
  listarMesas,
  guardarMesa,
  eliminarMesa
}
